"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _colors = _interopRequireDefault(require("../../colors"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var styles = function styles() {
  return {
    root: {
      fontFamily: 'proxima-soft, sans-serif',
      display: 'block',
      color: _colors["default"].typographyDark,
      lineHeight: '24px'
    },
    headline: {
      color: _colors["default"].purple,
      fontWeight: 700,
      fontSize: '32px',
      lineHeight: '48px'
    },
    title: {
      fontWeight: 400,
      fontSize: '24px',
      lineHeight: '32px'
    },
    header: {
      fontWeight: 600,
      fontSize: '21px'
    },
    subsectionHeader: {
      fontWeight: 400,
      fontSize: '17px',
      lineHeight: '30px'
    },
    bold: {
      fontWeight: 600,
      fontSize: '15px'
    },
    normal: {
      fontWeight: 400,
      fontSize: '15px'
    },
    meta: {
      color: _colors["default"].iconDark,
      fontWeight: 600,
      fontSize: '13px'
    },
    logo: {
      color: _colors["default"].white,
      fontWeight: 900,
      fontSize: '15px'
    },
    label: {
      color: _colors["default"].typographyLight,
      fontWeight: 400,
      fontSize: '13px'
    }
  };
};

exports.styles = styles;